// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: E4QEY4senUYo
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicTimeSelect.module.css"; // plasmic-import: E4QEY4senUYo/css
import ChevronDownSvgrepoCom1SvgIcon from "./icons/PlasmicIcon__ChevronDownSvgrepoCom1Svg"; // plasmic-import: kiKGEgdWctkm/icon
import Image1SvgIcon from "./icons/PlasmicIcon__Image1Svg"; // plasmic-import: 2SOf8Vr_upBY/icon

createPlasmicElementProxy;

export const PlasmicTimeSelect__VariantProps = new Array("postClick");

export const PlasmicTimeSelect__ArgProps = new Array("currentSelect");

const $$ = {};

function PlasmicTimeSelect__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "postClick",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.postClick
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root,
        { [sty.rootpostClick]: hasVariant($state, "postClick", "postClick") }
      )}
    >
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox, {
          [sty.freeBoxpostClick]: hasVariant($state, "postClick", "postClick")
        })}
      >
        {renderPlasmicSlot({
          defaultContents: "Today",
          value: args.currentSelect,
          className: classNames(sty.slotTargetCurrentSelect, {
            [sty.slotTargetCurrentSelectpostClick]: hasVariant(
              $state,
              "postClick",
              "postClick"
            )
          })
        })}
        {(hasVariant($state, "postClick", "postClick") ? true : false) ? (
          <ChevronDownSvgrepoCom1SvgIcon
            data-plasmic-name={"dropdownIcon3"}
            data-plasmic-override={overrides.dropdownIcon3}
            className={classNames(projectcss.all, sty.dropdownIcon3, {
              [sty.dropdownIcon3postClick]: hasVariant(
                $state,
                "postClick",
                "postClick"
              )
            })}
            role={"img"}
          />
        ) : null}
      </div>
      {(hasVariant($state, "postClick", "postClick") ? true : false) ? (
        <Image1SvgIcon
          data-plasmic-name={"dropdownIcon2"}
          data-plasmic-override={overrides.dropdownIcon2}
          className={classNames(projectcss.all, sty.dropdownIcon2, {
            [sty.dropdownIcon2postClick]: hasVariant(
              $state,
              "postClick",
              "postClick"
            )
          })}
          role={"img"}
        />
      ) : null}
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "freeBox", "dropdownIcon3", "dropdownIcon2"],
  freeBox: ["freeBox", "dropdownIcon3"],
  dropdownIcon3: ["dropdownIcon3"],
  dropdownIcon2: ["dropdownIcon2"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTimeSelect__ArgProps,
          internalVariantPropNames: PlasmicTimeSelect__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTimeSelect__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTimeSelect";
  } else {
    func.displayName = `PlasmicTimeSelect.${nodeName}`;
  }
  return func;
}

export const PlasmicTimeSelect = Object.assign(
  // Top-level PlasmicTimeSelect renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    dropdownIcon3: makeNodeComponent("dropdownIcon3"),
    dropdownIcon2: makeNodeComponent("dropdownIcon2"),
    // Metadata about props expected for PlasmicTimeSelect
    internalVariantProps: PlasmicTimeSelect__VariantProps,
    internalArgProps: PlasmicTimeSelect__ArgProps
  }
);

export default PlasmicTimeSelect;
/* prettier-ignore-end */
